import { render, staticRenderFns } from "./UsersNewBroadcast.vue?vue&type=template&id=2c8942df&scoped=true&"
import script from "./UsersNewBroadcast.vue?vue&type=script&lang=js&"
export * from "./UsersNewBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./UsersNewBroadcast.vue?vue&type=style&index=0&id=2c8942df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8942df",
  null
  
)

export default component.exports